import React from "react";
import { Route, Routes } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { LayoutData } from "../Structur/Aconlayout";
import { mainNav } from "./navigation";
//import { Home } from "../Pages/Home";
import { HomeProfi } from "../Event/Home/HomeProfi";

export const RenderMainRoutes = () => {
  const { user } = LayoutData();
  const publicUrl = process.env.REACT_APP_PUBLIC_URL;
  function UserControl(element){
//console.log('XXX Prüfe Homecheck ',user.statusOK,user.isAuthenticated);
    if (user.statusOK || !user.isAuthenticated) return element;
    else return element; // Kontrolle ob user noch was ausfüllen
  }

  //console.log('Render Main Root ');

  return (
    <Routes basename={publicUrl}>
      {mainNav().map((r, i) => {
        if (r.isDropdown && r.nav) {
          return r.nav.map((x, j) => {
            if (x.isPrivate && user.isAuthenticated) {
              return (
                <Route key={`${i}-${j}`} path={x.path} element={UserControl(x.element)}/>
              );
            } else if (!x.isPrivate) {
              return (
                <Route key={`${i}-${j}`} path={x.path} element={x.element} />
              );
            } else
              return (
                <Route key={`${i}-${j}`} path={"*"} element={<HomeProfi />} />
              );
          });
        } else {
          if (r.isPrivate && user.isAuthenticated) {
            return <Route key={i} path={r.path} element={UserControl(r.element)}  />;
          } else if (!r.isPrivate) {
            return <Route key={i} path={r.path} element={r.element} />;
          }
          else return <Route key={0} path={"*"} element={<HomeProfi />} />;
        }
      })}
    </Routes>
  );
};
